import React from "react";
import { useLocation } from "react-router-dom";

// #69: a render crash anywhere in the routed content (e.g. a screen indexing
// into state that a failed API call left undefined) previously unmounted the
// entire app — React has no default recovery from an uncaught error during
// render, so the user saw a fully blank page with no way back. This is the
// one boundary in the tree, placed around the route table so any single
// screen's crash degrades to an error message instead of a blank app.
class RouteErrorBoundaryClass extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Unhandled error in routed content:", error, info);
  }

  componentDidUpdate(prevProps) {
    // A caught render error otherwise sticks forever: this boundary sits
    // above <Routes>, so client-side navigation (a Link, a back/forward, the
    // "Back to dashboard" button reduced to router.navigate) re-renders the
    // same tree without unmounting it, and neither getDerivedStateFromError
    // nor componentDidCatch fires again to clear it. Resetting whenever the
    // route key changes means the fallback only ever covers the screen that
    // actually crashed, not every screen after it for the rest of the tab.
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="login-signup-wrap forget-wrap">
          <div className="container">
            <div className="row">
              <div className="col-12 text-center" style={{ padding: "80px 20px" }}>
                <h2>Something went wrong</h2>
                <p>
                  This screen hit an unexpected error. Try going back, or
                  reload the page.
                </p>
                <button
                  type="button"
                  className="auth-screen-btn mt-4"
                  style={{ maxWidth: "260px", margin: "0 auto" }}
                  onClick={() => window.location.assign("/dashboard")}
                >
                  Back to dashboard
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default function RouteErrorBoundary({ children }) {
  const location = useLocation();
  return (
    <RouteErrorBoundaryClass resetKey={location.key}>
      {children}
    </RouteErrorBoundaryClass>
  );
}
